/**
 * FAQ accordion — event delegation on the document so it:
 *  - survives editor hot-patches (ibizz:patch swaps block DOM wholesale),
 *  - handles any number of FAQ blocks per page (the old per-element binding
 *    only wired the first .Faq.Overview/.Faq.Detail).
 */
document.addEventListener("click", (e) => {
	const item = e.target.closest(".Faq.Item");
	if (!item || !item.closest(".Faq.Detail, .Faq.Overview")) return;
	item.classList.toggle("open");
});
